import {Injectable} from "@angular/core";
import {BehaviorSubject} from 'rxjs';
import {WorkbenchExpeditionService} from './workbench-expedition.service';


@Injectable()
export class WorkbenchAnnotationService {

    removeBookmarklets(scriptName: string, enable: boolean): string {
        return `
        (function() {
            console.log("Attempting to remove bookmarklet: a11y${scriptName}");
            if (window.a11y${scriptName}) {
                console.log("Bookmarklet found: a11y${scriptName}");
                window.a11y${scriptName}.show = ${!enable};
                window.a11y${scriptName}.run();
            } else {
                console.log("Bookmarklet not found: a11y${scriptName}");
            }
        })();
    `;
    }
    scriptNames = ['Headings', 'Landmarks', 'Images', 'Tables', 'Forms'];
    annotationsEnabled = new BehaviorSubject<boolean>(false);
    annotationsEnabled$ = this.annotationsEnabled.asObservable();

    constructor(private workbenchExpeditionService: WorkbenchExpeditionService) {}

    removeAnnotations() {
        this.workbenchExpeditionService.sendCDPCommand('Runtime.evaluate', {
            expression: `window.WebmateInfusion.clearHudItems();`
        }).subscribe({
            next: res => {
            },
            error: err => {
                console.error('Error while removing highlight elements', err);
            }
        });
        this.scriptNames.forEach(scriptName => {
            this.workbenchExpeditionService.sendCDPCommand('Runtime.evaluate', {
                expression: this.removeBookmarklets(scriptName,false)
            }).subscribe({
                next: res => {
                    console.debug(`Successfully evaluated removal for: ${scriptName}`);
                },
                error: err => {
                    console.error(`Error while removing bookmarklet: ${scriptName}`, err);
                }
            });
        });
        this.annotationsEnabled.next(false);
    }
}